import api from './api.js';
import { Scheme } from './scripts/scheme/scheme';

api.Scheme = Scheme;

export default api;
